import Vue from "vue";
import VueI18n from "vue-i18n";
import zhCN from '../languages/zh'
import enUS from "../languages/en";
import ptBr from "../languages/pt-br";
import { Locale } from "vant";
import vantZhCN from "vant/lib/locale/lang/zh-CN";
import vantEnUS from "vant/lib/locale/lang/en-US";
import favUtil  from "../utils/fav-util";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: favUtil.getLanguage(),
  // locale: "en-US",
  messages: {
    "zh-CN": zhCN,
    "en-US": enUS,
    "pt-br": ptBr
  }
});

export const vantLocale = locale => {
  if (locale === "zh-CN") {
    Locale.use(locale, vantZhCN);
  } else {
    Locale.use(locale, vantEnUS);
  }
};

export default i18n;
